import { __decorate, __metadata } from "tslib";
import { Component, Emit, Mixins, Prop } from 'vue-property-decorator';
import BaseVue from '~/nasa_ui/base/BaseVue';
import { DEFAULT_DASH } from '~/nasa_ui/constants';
import CurrentUserMixin from '~/nasa_ui/mixins/CurrentUserMixin';
import { UserPermission } from '~/nasa_ui/types';
import { isNullOrUndefined } from '~/nasa_ui/utils/helpers/isNullOrUndefined';
let TheTopNavBar = class TheTopNavBar extends Mixins(BaseVue, CurrentUserMixin) {
    applicationVersion = '';
    UserPermission = UserPermission;
    hasApplicationSpecificCreateMenuItems;
    routeConfigs;
    showMyApprovalQueueLink;
    get currentUserNavbarSettings() {
        return (this.currentUserActiveSupportContext &&
            this.currentUser?.attributes?.navbar?.[this.currentUserActiveSupportContext]);
    }
    get currentUserQuickReportSettings() {
        if (!this.currentUserActiveSupportContext) {
            return [];
        }
        // if quickReports obj doesn't exist, make it
        if (this.currentUser && this.currentUserActiveSupportContext && !this.currentUser.attributes.quickReports) {
            this.currentUser.attributes.quickReports = {};
        }
        // if supportContext array doesn't exist, make it
        if (this.currentUser &&
            this.currentUserActiveSupportContext &&
            !this.currentUser.attributes.quickReports[`${this.currentUserActiveSupportContext}`]) {
            this.currentUser.attributes.quickReports[`${this.currentUserActiveSupportContext}`] = [];
        }
        return this.currentUser?.attributes?.quickReports[this.currentUserActiveSupportContext]?.filter((qr) => {
            // find the report routes that are NOT in this app
            return this.$router.options.routes
                ?.filter((route) => route.path.startsWith('/reporting'))
                ?.filter((route) => Boolean(route.meta) && !route.meta?.doNotList)
                ?.filter((route) => {
                // Permission check
                const _meta = route.meta;
                if (!_meta?.permissions) {
                    return true;
                }
                if (!_meta?.permissions.length) {
                    return true;
                }
                return _meta.permissions?.every((perm) => this.currentUserHasPermission(perm));
            })
                ?.filter((route) => {
                // User Role check
                const _meta = route.meta;
                if (!_meta?.userRoles) {
                    return true;
                }
                if (!_meta?.userRoles.length) {
                    return true;
                }
                return Boolean(this.currentUserHasUserRole(_meta.userRoles));
            })
                .map((route) => {
                return {
                    _reportName: route.meta?.displayName || DEFAULT_DASH,
                    _description: route.meta?.description || DEFAULT_DASH,
                    ...route
                };
            })
                .find((route) => {
                return route._reportName === qr._reportName;
            }); // false when not found
        });
    }
    get shouldShowMyApprovals() {
        return isNullOrUndefined(this.currentUserNavbarSettings?.showMyApprovals)
            ? true
            : this.currentUserNavbarSettings?.showMyApprovals;
    }
    get shouldShowNewBrowserWindowIcon() {
        return isNullOrUndefined(this.currentUserNavbarSettings?.showNewBrowserWindowIcon)
            ? true
            : this.currentUserNavbarSettings?.showNewBrowserWindowIcon;
    }
    get shouldShowGetSupportIcon() {
        return isNullOrUndefined(this.currentUserNavbarSettings?.showGetSupportIcon)
            ? true
            : this.currentUserNavbarSettings?.showGetSupportIcon;
    }
    get shouldShowUserSupport() {
        return isNullOrUndefined(this.currentUserNavbarSettings?.showUserSupport)
            ? true
            : this.currentUserNavbarSettings?.showUserSupport;
    }
    // This is intended to say "can you see any of the base type creates? if you can see at least 1 we show the create icon"
    get shouldShowAnySharedCreate() {
        return (this.shouldShowCreateMenuApprovalRoutingTemplate ||
            this.shouldShowCreateMenuContact ||
            this.shouldShowCreateMenuLocation ||
            this.shouldShowCreateMenuOrganization ||
            this.shouldShowCreateMenuUser ||
            this.shouldShowCreateMenuUserGroup);
    }
    get shouldShowCreateMenuContact() {
        return this.currentUserHasPermission(UserPermission.CONTACT_ADMIN);
    }
    get shouldShowCreateMenuLocation() {
        return this.currentUserHasPermission(UserPermission.LOCATION_ADMIN);
    }
    get shouldShowCreateMenuOrganization() {
        return this.currentUserHasPermission(UserPermission.ORGANIZATION_ADMIN);
    }
    get shouldShowCreateMenuUser() {
        return this.currentUserHasPermission(UserPermission.USER_ADMIN);
    }
    get shouldShowCreateMenuUserGroup() {
        return this.currentUserHasPermission(UserPermission.USER_GROUPS_ADMIN);
    }
    get shouldShowCreateMenuApprovalRoutingTemplate() {
        return this.currentUserHasPermission(UserPermission.APPROVAL_ROUTING_TEMPLATE_ADMIN);
    }
    get shouldShowReportingMenu() {
        return true;
    }
    get reportingRoutes() {
        let items = [];
        if (this.currentUserQuickReportSettings.length) {
            items = [...this.currentUserQuickReportSettings];
        }
        else {
            items = [...this.routeConfigs];
        }
        // filter out those not for the current context
        items = items.filter((r) => {
            if (!r.meta.supportContexts.length) {
                return true;
            }
            return r.meta.supportContexts.includes(this.currentUserActiveSupportContext);
        });
        return items;
    }
    created() {
        this.$listen('application_version', (version) => {
            this.applicationVersion = version;
        });
        this.$listen('quick_reports_updated', (currentUser) => {
            this.currentUser = currentUser;
        });
        this.$listen('user_updated', (currentUser) => {
            this.currentUser = currentUser;
        });
    }
    highlightNavbarItem(itemRefName) {
        if (itemRefName && this.$refs[itemRefName]) {
            this.$refs[itemRefName].classList.add('highlight');
        }
        else {
            this.$el.querySelectorAll('.nav_bar_item').forEach((item) => {
                item?.classList.remove('highlight');
            });
        }
    }
    emitShowApplicationChangeLog() { }
};
__decorate([
    Prop({
        type: Boolean,
        required: false,
        default: true
    }),
    __metadata("design:type", Boolean)
], TheTopNavBar.prototype, "hasApplicationSpecificCreateMenuItems", void 0);
__decorate([
    Prop({
        type: Array,
        required: false,
        default: () => []
    }),
    __metadata("design:type", Array)
], TheTopNavBar.prototype, "routeConfigs", void 0);
__decorate([
    Prop({
        type: Boolean,
        required: false,
        default: false
    }),
    __metadata("design:type", Boolean)
], TheTopNavBar.prototype, "showMyApprovalQueueLink", void 0);
__decorate([
    Emit('show_application_change_log'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], TheTopNavBar.prototype, "emitShowApplicationChangeLog", null);
TheTopNavBar = __decorate([
    Component
], TheTopNavBar);
export default TheTopNavBar;
